import { render, staticRenderFns } from "./RouteLabel.vue?vue&type=template&id=3c12fee7&scoped=true&"
import script from "./RouteLabel.vue?vue&type=script&lang=js&"
export * from "./RouteLabel.vue?vue&type=script&lang=js&"
import style0 from "./RouteLabel.vue?vue&type=style&index=0&id=3c12fee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12fee7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
